import React from 'react';

export const userContext = React.createContext();
const { Provider, Consumer } = userContext;
export const UserProvider = Provider;
export const UserConsumer = Consumer;
